import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5e12000"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold" }, "Откуда", -1))
const _hoisted_3 = { class: "font-semibold" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold" }, "Куда", -1))
const _hoisted_8 = { class: "mt-3 flex items-center justify-between" }
const _hoisted_9 = {
  key: 0,
  class: "w-full flex items-center justify-center select-none"
}
const _hoisted_10 = {
  key: 1,
  class: "Table"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "TableHeader" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Месяц"),
  /*#__PURE__*/_createElementVNode("div", null, "Тг/кг"),
  /*#__PURE__*/_createElementVNode("div", null, "20-тонник"),
  /*#__PURE__*/_createElementVNode("div", null, "10-тонник"),
  /*#__PURE__*/_createElementVNode("div", null, "5-тонник"),
  /*#__PURE__*/_createElementVNode("div", null, "3-тонник"),
  /*#__PURE__*/_createElementVNode("div", null, "Газель")
], -1))
const _hoisted_12 = { class: "TableBody" }
const _hoisted_13 = { class: "flex justify-center items-center" }
const _hoisted_14 = { class: "flex justify-center items-center" }
const _hoisted_15 = { class: "grid grid-cols-2 gap-3 items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Бюджет:", -1))
const _hoisted_17 = { class: "mt-2 grid grid-cols-2 gap-3 items-center" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Тг/м3:", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_radio_group = _resolveComponent("radio-group")!
  const _component_loader = _resolveComponent("loader")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "max",
    scrollable: "",
    title: _ctx.modalTitle,
    "confirm-button-text": _ctx.confirmButtonText,
    loading: _ctx.isLoading,
    onCancel: _ctx.onCancel,
    onConfirm: _ctx.onConfirm
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_the_select, {
          value: _ctx.state.sender_city,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.sender_city) = $event)),
          placeholder: "Выберите из списка",
          loading: _ctx.cities_state.is_loading,
          disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
          failed: _ctx.cities_state.is_failed,
          options: _ctx.cities_state.list,
          "error-text": "При получении списка городов произошла ошибка",
          "is-invalid": _ctx.state_form$.sender_city.$error,
          "validation-errors": _ctx.state_form$.sender_city.$errors,
          onRefresh: _ctx.loadCities
        }, null, 8, ["value", "loading", "disabled", "failed", "options", "is-invalid", "validation-errors", "onRefresh"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.transit_cities, (city, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: `transit-city-${i}`,
            class: "grid grid-cols-1 gap-3"
          }, [
            _createElementVNode("div", _hoisted_3, "Транзит №" + _toDisplayString(i + 1), 1),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_the_select, {
                class: "w-full",
                value: _ctx.state.transit_cities[i],
                "onUpdate:value": ($event: any) => ((_ctx.state.transit_cities[i]) = $event),
                placeholder: "Выберите из списка",
                loading: _ctx.cities_state.is_loading,
                disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                failed: _ctx.cities_state.is_failed,
                options: _ctx.cities_state.list,
                "error-text": "При получении списка городов произошла ошибка",
                onRefresh: _ctx.loadCities
              }, null, 8, ["value", "onUpdate:value", "loading", "disabled", "failed", "options", "onRefresh"]),
              _createVNode(_component_the_button, {
                class: "red text small",
                onClick: ($event: any) => (_ctx.deleteTransitCity(i))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]))
        }), 128)),
        _createVNode(_component_the_button, {
          class: "primary text small",
          onClick: _ctx.addTransitCity
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createTextVNode(" Добавить город транзит ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        _hoisted_7,
        _createVNode(_component_the_select, {
          value: _ctx.state.receiver_city,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.receiver_city) = $event)),
          placeholder: "Выберите из списка",
          loading: _ctx.cities_state.is_loading,
          disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
          failed: _ctx.cities_state.is_failed,
          options: _ctx.cities_state.list,
          "error-text": "При получении списка городов произошла ошибка",
          "is-invalid": _ctx.state_form$.receiver_city.$error,
          "validation-errors": _ctx.state_form$.receiver_city.$errors,
          onRefresh: _ctx.loadCities
        }, null, 8, ["value", "loading", "disabled", "failed", "options", "is-invalid", "validation-errors", "onRefresh"]),
        _createVNode(_component_the_select, {
          "can-deselect": "",
          placeholder: "Тип перевозки",
          value: _ctx.state.invoiceType,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.invoiceType) = $event)),
          disabled: _ctx.state.is_loading,
          options: _ctx.TRANSPORTATION_TYPES,
          class: "mt-2"
        }, null, 8, ["value", "disabled", "options"]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_radio_group, {
            options: _ctx.QUARTERS,
            value: _ctx.state.quarter,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.quarter) = $event)),
            class: "small"
          }, null, 8, ["options", "value"]),
          (_ctx.isLtl)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 0,
                class: "primary small",
                loading: _ctx.state.is_calculate_loading,
                disabled: _ctx.state.is_calculate_loading,
                onClick: _ctx.calculate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Рассчитать ")
                ]),
                _: 1
              }, 8, ["loading", "disabled", "onClick"]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.state.is_calculate_loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_loader, { class: "primary" })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getItems, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `item-${index}`,
                    class: "TableBody__row"
                  }, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.MONTHS[item.monthId - 1]), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_the_input, {
                        placeholder: "Тг/кг",
                        disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                        value: item.costPerWeight,
                        "onUpdate:value": ($event: any) => ((item.costPerWeight) = $event),
                        type: "number"
                      }, null, 8, ["disabled", "value", "onUpdate:value"])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.costStandardsByMonth, (subitem, subindex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `subitem-${subindex}`
                      }, [
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createVNode(_component_the_input, {
                            placeholder: "Вес",
                            disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                            value: subitem.cost,
                            "onUpdate:value": ($event: any) => ((subitem.cost) = $event),
                            type: "number"
                          }, null, 8, ["disabled", "value", "onUpdate:value"])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createVNode(_component_the_input, {
                            placeholder: "Кубатура",
                            disabled: _ctx.cities_state.is_loading || _ctx.state.is_loading,
                            value: subitem.costPerCubature,
                            "onUpdate:value": ($event: any) => ((subitem.costPerCubature) = $event),
                            type: "number"
                          }, null, 8, ["disabled", "value", "onUpdate:value"])
                        ])
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ])
            ]))
      ])
    ]),
    _: 1
  }, 8, ["title", "confirm-button-text", "loading", "onCancel", "onConfirm"]))
}